import { Card } from 'antd';
import MapBlock from '../../components/MapBlock/MapBlock.jsx';
import { InvestProGate } from '../../models/investProModel/index.js';

function InvestPro() {
  return (
    <div>
      <InvestProGate />
      <Card
        variant="borderless"
        className="map_card"
        style={{ height: '100dvh' }}
        bodyStyle={{ height: '100%' }}
      >
        <MapBlock />
      </Card>{' '}
    </div>
  );
}

export default InvestPro;
